"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderTokensHost = void 0;
var react_1 = __importDefault(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var RenderToken_1 = require("./RenderToken");
var RenderTokensHost = function (_a) {
    var e_1, _b;
    var tokens = _a.tokens;
    if (tokens.every(function (token) { return token.type === "inline"; })) {
        return (react_1.default.createElement(react_1.default.Fragment, null, tokens.map(function (token, index) {
            return react_1.default.createElement(RenderToken_1.RenderToken, { key: index, token: token, childTokens: [] });
        })));
    }
    var tokenChunks = [];
    try {
        for (var tokens_1 = __values(tokens), tokens_1_1 = tokens_1.next(); !tokens_1_1.done; tokens_1_1 = tokens_1.next()) {
            var token = tokens_1_1.value;
            (0, tiny_invariant_1.default)(token, "Token is undefined");
            if (token.type === "block") {
                tokenChunks.push({ token: token, children: [] });
            }
            else {
                var currentBlockChunk = tokenChunks[tokenChunks.length - 1];
                (0, tiny_invariant_1.default)(currentBlockChunk, "Current block chunk is undefined");
                currentBlockChunk.children.push(token);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tokens_1_1 && !tokens_1_1.done && (_b = tokens_1.return)) _b.call(tokens_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var renderedBlocks = tokenChunks.map(function (tokenChunk, index) {
        return react_1.default.createElement(RenderToken_1.RenderToken, { key: index, token: tokenChunk.token, childTokens: tokenChunk.children });
    });
    return react_1.default.createElement(react_1.default.Fragment, null, renderedBlocks);
};
exports.RenderTokensHost = RenderTokensHost;
